export default "__VITE_ASSET__as2l7nY___"